import React from 'react';
import {
    SkeletonBodyText,
    Page,
    PageActions,
    Card,
    Layout,
    TextField,
    Banner,
    RadioButton,
    Select,
    Stack
} from '@shopify/polaris';
import { apiFetch as fetch } from '../../common/Helpers';
import { Helmet } from 'react-helmet';

const cronOptions = [
    { label: 'Every 15 minutes', value: 'Every15Minutes' },
    { label: 'Every 30 minutes', value: 'Every30Minutes' },
    { label: 'Every hour', value: 'EveryHour' },
    { label: 'Every 6 hours', value: 'Every6Hours' },
    { label: 'Every 12 hours', value: 'Every12Hours' },
    { label: 'Every Day (At 00:00)', value: 'EveryDay' },
    { label: 'Every Week (At 00:00 on Sunday)', value: 'EveryWeek' },
    { label: 'Every Month (At 00:00 on the first day of every month)', value: 'EveryMonth' },
];

class ViewAutomationPage extends React.Component {

    constructor(props) {
        super(props);

        const { params } = this.props.match;

        this.state = {
            id: params.id,
            isLoading: true,
            automation: {
                name: null,
                automationType: null,
                automationValue: null,
                operationId: null
            },
            nameError: null,
            popoverActive: false,
            operations: [],
            operationError: this.getOperationError(null),
            operationHasExistingAutomation: false,
            automationOriginalName: null,
            automationOriginalAutomationType: null,
            automationOriginalAutomationValue: null,
            automationOriginalOperationId: null,
        };
    }

    render() {

        const nameChanged = this.state.automationOriginalName !== this.state.automation.name;
        const automationTypeChanged = this.state.automationOriginalAutomationType !== this.state.automation.automationType;
        const automationValueChanged = this.state.automationOriginalAutomationValue !== this.state.automation.automationValue;
        const automationOperationIdChanged = this.state.automationOriginalOperationId !== this.state.automation.operationId;
        const hasError = this.state.nameError != null;
        const hasChanges = nameChanged || automationTypeChanged || automationValueChanged || automationOperationIdChanged;
        const canSave = hasChanges && !hasError && !this.state.operationHasExistingAutomation;
        var primary = { content: 'Save', onAction: this.handleSave, disabled: !canSave };
        // var secondary = { content: 'Execute', onAction: () => { this.handleRun(); } };

        let options = this.state.operations.map((_) => {
            return { label: _.description, value: _.id }
        });

        options = [
            { label: "--- Choose tag operation ---", value: "" },
            ...options,
        ];

        return (

            <div>
                <Helmet>
                    <title>{"Tag Genie - Automation - " + this.state.id}</title>
                </Helmet>
                {this.state.isLoading && <SkeletonBodyText lines="20" />}
                {!this.state.isLoading && <Page
                    title={"View Automation"}
                    primaryAction={primary}
                    // secondaryActions={[secondary]}
                    breadcrumbs={[{ content: 'Automations', url: '/automations' }]}
                >
                    <Layout>
                        <Layout.Section>
                            <Card title="Name" sectioned>
                                <TextField
                                    value={this.state.automation.name}
                                    error={this.state.nameError}
                                    onChange={this.handleNameChange}></TextField>
                            </Card>
                        </Layout.Section>
                        <Layout.Section>
                            <Card title="Operation to automate" sectioned>
                                <Select
                                    options={options}
                                    onChange={this.handleSelectedChanged}
                                    value={this.state.automation.operationId}
                                    error={this.state.operationError}
                                />
                                <br />
                                {this.state.operationHasExistingAutomation && <Banner
                                    title="Already has automation"
                                    status="critical"
                                >
                                    <p>
                                        This operation has another automation associated with it. Only one automation per operation is allowed.
                                    </p>
                                </Banner>
                                }
                            </Card>
                        </Layout.Section>
                        <Layout.Section>
                            <Card title="Automation Type" sectioned>
                                <Stack vertical>
                                    <RadioButton
                                        label="Recurring"
                                        helpText="Operation will be executed on a recurring schedule."
                                        checked={this.state.automation.automationType === 'cron'}
                                        id="automationTypeCron"
                                        name="automationType"
                                        onChange={this.handleCronSelected}
                                    />
                                    <RadioButton
                                        label="Specific Datte & Time"
                                        helpText="The operation will be executed one time at the specified date & time."
                                        id="automationTypeDateTime"
                                        name="automationType"
                                        checked={this.state.automation.automationType === 'dateTime'}
                                        onChange={this.handleDateTimeSelected}
                                    />
                                </Stack>
                                <Card.Section>
                                    <Stack>
                                        {this.state.automation.automationType === "cron" && <Select
                                            label="Frequency"
                                            options={cronOptions}
                                            onChange={this.handleFrequencyChange}
                                            value={this.state.automation.automationValue}
                                        />
                                        }

                                        {this.state.automation.automationType === "dateTime" && <TextField
                                            label="Execution time"
                                            type="datetime-local"
                                            onChange={this.handleExecutionTimeChange}
                                            value={this.state.automation.automationValue}
                                        />
                                        }
                                    </Stack>
                                </Card.Section>
                            </Card>
                        </Layout.Section>
                    </Layout>
                    <PageActions
                        primaryAction={primary}
                        secondaryActions={[
                            {
                                content: 'Delete',
                                onAction: this.handleDelete,
                                destructive: true,
                            },
                        ]}
                    />
                </Page>}
            </div>
        );
    }

    handleSelectedChanged = (selected) => {
        var newAutomation = { ...this.state.automation };
        newAutomation.operationId = selected;

        this.setState({
            automation: newAutomation,
            operationError: this.getOperationError(selected)
        });

        this.fetchOperationStatus(selected);
    }

    togglePopoverActive = () => {
        this.setState({ popoverActive: !this.state.popoverActive });
    }

    handleCronSelected = () => {
        var newAutomation = { ...this.state.automation };

        newAutomation.automationType = "cron";
        newAutomation.automationValue = "EveryHour";

        this.setState({ automation: newAutomation });
    }

    handleDateTimeSelected = () => {
        let initDate = new Date();
        initDate.setDate(initDate.getDate() + 1);

        var newAutomation = { ...this.state.automation };

        newAutomation.automationType = "dateTime";
        newAutomation.automationValue = this.formatDate(initDate);

        this.setState({ automation: newAutomation });
    }

    pad(number) {
        var r = String(number);
        if (r.length === 1) {
            r = '0' + r;
        }
        return r;
    }

    formatDate(date) {
        return date.getUTCFullYear() +
            '-' + this.pad(date.getMonth() + 1) +
            '-' + this.pad(date.getDate()) +
            'T' + this.pad(date.getHours()) +
            ':' + this.pad(date.getMinutes());
    };

    handleFrequencyChange = (value) => {
        var newAutomation = { ...this.state.automation };
        newAutomation.automationValue = value;

        this.setState({ automation: newAutomation });
    }

    handleExecutionTimeChange = (value) => {
        var newAutomation = { ...this.state.automation };
        newAutomation.automationValue = value;

        this.setState({ automation: newAutomation });
    }

    handleNameChange = (newValue) => {
        var newAutomation = { ...this.state.automation };
        newAutomation.name = newValue;
        this.setState({
            automation: newAutomation,
            nameError: this.getNameError(newValue)
        });
    }

    getNameError = (name) => {
        return (name === "" || name === null) ? "Name is required" : null;
    }

    getOperationError = (operationId) => {
        return (operationId === "" || operationId === null) ? "Operation must be selected" : null;
    }

    handleDelete = () => {
        fetch(`api/automations/${this.state.id}`, {
            method: 'DELETE'
        }).then(() => {
            this.props.history.push("/automations");
        });
    }

    handleSave = () => {

        let finalAutomationValue = this.state.automation.automationValue;
        if (this.state.automation.automationType === "dateTime") {
            finalAutomationValue = (new Date(this.state.automation.automationValue)).toISOString();
        }

        fetch(`api/automations/${this.state.id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: this.state.automation.name,
                type: this.state.automation.automationType,
                value: finalAutomationValue,
                operationId: this.state.automation.operationId,
                id: this.state.id
            })
        })
            .then(_ => {
                this.setState({
                    automationOriginalName: this.state.automation.name,
                    automationOriginalAutomationType: this.state.automation.automationType,
                    automationOriginalAutomationValue: this.state.automation.automationValue,
                    automationOriginalOperationId: this.state.automation.operationId
                });
            });;
    }

    fetchOperations = () => {
        fetch(`api/operations/latest`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                operations: data
            }));
    }

    fetchOperationStatus = (operationId) => {
        fetch(`api/operations/tag/${operationId}/status`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {

                this.setState({
                    operationHasExistingAutomation: data.hasAutomation,
                });
            });
    }

    componentDidMount() {
        this.fetchOperations();

        fetch(`api/automations/${this.state.id}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {

                //TODO: Fix this
                if (data.automationType === "dateTime") {
                    let localExecutionTime = this.formatDate(new Date(data.automationValue))
                    data.automationValue = localExecutionTime;
                }

                this.setState({
                    automation: data,
                    isLoading: false,
                    automationOriginalName: data.name,
                    automationOriginalAutomationType: data.automationType,
                    automationOriginalAutomationValue: data.automationValue,
                    automationOriginalOperationId: data.operationId,
                    nameError: this.getNameError(data.name),
                    operationError: this.getOperationError(data.operationId),
                });
            });
    }
}

export default ViewAutomationPage;